import React from 'react'
import { Locale, Translation } from 'locale'
import { ColumnMappingDecimal, AmountFormat } from 'api'
import { getAmountFormat, getDecimalShift } from 'model'
import { LabelPosition, LabelAlignment } from 'view/styles/constants'
import { AmountFormatSelectboxField } from 'view/shared/entity'
import { ColumnMappingPanelProps, ColumnMappingPanel } from './ColumnMappingPanel'
import { ColumnMappingHeaderSelectbox } from './ColumnMappingHeaderSelectbox'

export const ColumnMappingDecimalPanel: React.FunctionComponent<ColumnMappingPanelProps<ColumnMappingDecimal>> = props => {
  const { fieldTitle, fieldName, columnMapping, parseResult, onUpdate } = props

  const handleUpdateAmountFormat = (amountFormat: AmountFormat) =>
    onUpdate({ ...columnMapping, decimalShift: getDecimalShift(amountFormat) }, fieldName)

  return (
    <ColumnMappingPanel>
      <ColumnMappingHeaderSelectbox
        fieldTitle={fieldTitle}
        fieldName={fieldName}
        columnMapping={columnMapping}
        parseResult={parseResult}
        onUpdate={onUpdate}
      />
      <AmountFormatSelectboxField
        label={Locale.translate(Translation.SC_AMOUNT_FORMAT)}
        labelPosition={LabelPosition.Left}
        labelAlignment={LabelAlignment.Right}
        value={getAmountFormat(columnMapping.decimalShift)}
        onUpdate={handleUpdateAmountFormat}
      />
    </ColumnMappingPanel>
  )
}
